import { CloseIconThin } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export interface CloseButtonProps {
  onClose: () => void
  'data-testid'?: string
}

export const CloseButton: React.FC<CloseButtonProps> = ({ onClose, ...props }) => {
  const { t } = useTranslation('common')

  return (
    <button
    className='ch-c-button ch-c-button--transparent ch-c-button--close ds-u-padding--0'
    aria-label={t('close')}
    onClick={onClose}
    type='button'
    data-testid={props['data-testid']}
  >
    <CloseIconThin />
  </button>
  )
}
